import React from 'react';
import { IconProps } from '../../DefaultIcon';
export function ModelsIcon({ className }: IconProps) {
  return (
    <svg
      width="88"
      height="85"
      viewBox="0 0 88 85"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_1839)">
        <path
          d="M60.0185 66.3999H28.0068V79.3629H60.0185V66.3999Z"
          fill="#EAEDF8"
        />
        <path
          d="M83.1995 68.8157H4.80047C2.15636 68.8157 0 66.6336 0 63.9578V4.85788C0 2.18215 2.15636 0 4.80047 0H83.1995C85.8436 0 88 2.18215 88 4.85788V63.9578C88 66.6336 85.8436 68.8157 83.1995 68.8157Z"
          fill="#EAEDF8"
        />
        <path
          d="M73.2132 85.0001H14.8118C13.2715 85.0001 12.0137 83.7272 12.0137 82.1685C12.0137 80.6098 13.2715 79.3369 14.8118 79.3369H73.2132C74.7535 79.3369 76.0113 80.6098 76.0113 82.1685C76.0113 83.7272 74.7535 85.0001 73.2132 85.0001Z"
          fill="#EAEDF8"
        />
        <path
          d="M79.6054 62.7366H8.39423C7.05934 62.7366 6.00684 61.6455 6.00684 60.3207V8.49457C6.00684 7.14371 7.08502 6.07861 8.39423 6.07861H79.6054C80.9403 6.07861 81.9928 7.16969 81.9928 8.49457V60.3207C81.9928 61.6715 80.9147 62.7366 79.6054 62.7366Z"
          fill="white"
        />
        <path
          d="M53.2418 26.0041C53.2418 25.2507 52.7798 24.6012 52.1123 24.2895L38.1987 18.0548C37.7109 17.847 37.1462 17.847 36.6584 18.0548L22.7448 24.2895C22.0773 24.6012 21.6409 25.2507 21.6152 26.0041C21.6152 26.134 21.6152 26.108 21.6152 26.2379V26.3678V40.9414C21.6152 41.6688 22.026 42.3442 22.6677 42.656L36.5814 49.5661C36.8381 49.696 37.1205 49.7479 37.4285 49.7479C37.7366 49.7479 37.9933 49.696 38.2757 49.5661L52.1893 42.656C52.8311 42.3442 53.2418 41.6688 53.2418 40.9414V26.2638C53.2418 26.2638 53.2418 26.108 53.2418 25.9781V26.0041ZM37.4285 21.8995L46.8754 26.134L37.4285 30.81L27.9816 26.134L37.4285 21.8995ZM25.3889 29.1214L35.5289 34.1352V44.7602L25.3889 39.7204V29.0954V29.1214ZM39.3025 44.7862V34.1611L49.4425 29.1474V39.7724L39.3025 44.8121V44.7862Z"
          fill="#00416B"
        />
        <path
          d="M67.3606 36.2395C67.3606 35.7199 67.0526 35.2523 66.5905 35.0445L56.9639 30.7321C56.6302 30.5763 56.2451 30.5763 55.9114 30.7321L46.2848 35.0445C45.8227 35.2523 45.5146 35.7199 45.5146 36.2395C45.5146 36.3434 45.5146 36.3174 45.5146 36.3953V36.4993V46.5787C45.5146 47.0723 45.797 47.5399 46.2334 47.7737L55.86 52.5536C56.0397 52.6316 56.2451 52.6835 56.4505 52.6835C56.6558 52.6835 56.8355 52.6316 57.0409 52.5536L66.6675 47.7737C67.1039 47.5399 67.3863 47.0983 67.3863 46.5787V36.4473C67.3863 36.4473 67.3863 36.3434 67.3863 36.2654L67.3606 36.2395ZM56.4248 33.4079L62.9452 36.3434L56.4248 39.5647L49.9044 36.3434L56.4248 33.4079ZM48.1074 38.3956L55.1156 41.8767V49.2285L48.1074 45.7474V38.3956ZM57.734 49.2285V41.8767L64.7422 38.3956V45.7474L57.734 49.2285Z"
          fill="#00C4B3"
        />
        <path
          d="M48.1074 38.3955V45.7473L55.1156 49.2024V41.8766L48.1074 38.3955Z"
          fill="white"
        />
        <path
          d="M49.9043 36.317L54.5764 34.2388L53.6779 38.2134L49.9043 36.317Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_1839">
          <rect width="88" height="85" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
